module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-city-1911d812b378a8395804aa41e019b616.svg";